<template>
    <div class="sl-card">
        <!-- Title -->
        <div class="sl-card__title">
            {{ $t('card.return_price.title') }}
        </div>

        <!-- Return Price -->
        <div class="sl-card-details__price-line">
            <!-- Return Policy Label or Price Message -->
            <div
                v-if="!oReturn.price_information?.message"
                class="sl-card-details__price-line-label"
            >
                {{ oReturn.return_policy.label }}
            </div>

            <div v-else class="sl-card-details__price-line-label !text-red-600">
                {{ oReturn.price_information.message }}
            </div>

            <!-- Return Price (calculated by Policy) -->
            <div
                class="sl-card-details__price-line-value"
                :class="{ 'blur': !isPriceVisible }"
            >
                {{ oReturn.currency_code }}&nbsp;{{ $f(oReturn.price, 'decimal:2') }}
            </div>
        </div>

        <!-- Return Special Price -->
        <div v-if="oReturn.special_price" class="sl-card-details__price-line">
            <div class="sl-card-details__price-line-label">
                {{ t('return_table.details.special_price.label') }}
            </div>

            <div
                class="sl-card-details__price-line-value"
                :class="{ 'blur': !isPriceVisible }"
            >
                {{ oReturn.currency_code }}&nbsp;{{ $f(oReturn.special_price, 'decimal:2') }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

// ------------------------------------------------------------ PROPS

defineProps({
    oReturn:
    {
        type:     Object,
        required: true,
    },
});

// ------------------------------------------------------------ COMPOSABLES

const store = useStore();
const { t } = useI18n({ useScope: 'global' });

// ------------------------------------------------------------ COMPUTED

const isPriceVisible = computed(() => store.state.pricesVisible);
</script>
